export default "__VITE_ASSET__C7FEY4Wv__"